import { keepTrackApi } from '@app/keepTrackApi';
import { Line, LineColors } from './line';
export class SatToSunLine extends Line {
    sat;
    constructor(sat) {
        super();
        this.sat = sat;
        this.color_ = LineColors.ORANGE;
    }
    update() {
        const eci = this.sat.eci(keepTrackApi.getTimeManager().simulationTimeObj);
        if (!eci) {
            this.isGarbage = true;
            return;
        }
        const eciArr = [eci.position.x, eci.position.y, eci.position.z];
        this.updateVertBuf([eciArr, keepTrackApi.getScene().sun.position]);
    }
}
